module.exports = __webpack_public_path__ + "img/ic_12_plus.cfa78800.svg";